"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _EmptyResult = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/EmptyResult"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = {
  "container": "container_3QF80H"
}; 
require('./EmptySection.css');
var EmptySection = /*#__PURE__*/function (_React$PureComponent) {
  function EmptySection() {
    (0, _classCallCheck2.default)(this, EmptySection);
    return _callSuper(this, EmptySection, arguments);
  }
  (0, _inherits2.default)(EmptySection, _React$PureComponent);
  return (0, _createClass2.default)(EmptySection, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        title = _this$props.title,
        children = _this$props.children,
        className = _this$props.className,
        testId = _this$props.testId;
      return /*#__PURE__*/_react.default.createElement("div", {
        "data-test-id": testId,
        className: (0, _classnames.default)(className, styles.container)
      }, /*#__PURE__*/_react.default.createElement(_EmptyResult.default, {
        message: ""
      }), /*#__PURE__*/_react.default.createElement("h4", null, title), children);
    }
  }]);
}(_react.default.PureComponent);
(0, _defineProperty2.default)(EmptySection, "propTypes", {
  title: _propTypes.default.string.isRequired,
  children: _propTypes.default.node.isRequired,
  className: _propTypes.default.string,
  testId: _propTypes.default.string
});
(0, _defineProperty2.default)(EmptySection, "defaultProps", {
  testId: 'empty-section'
});
var _default = exports.default = EmptySection;
//# sourceMappingURL=EmptySection.js.map